import FilterBar from './FilterBar';
import FilterWrapper from './FilterWrapper';

// Wrap the FilterBar with state handlers
const CustomFilter = FilterWrapper(FilterBar);

export default CustomFilter;
